<div *ngIf="show" class="alert app-message ng-isolate-scope" [ngClass]="[messageClass, customClass]">
    <div><i title="{{type}} Alert" class="{{type}} icon {{messageIconClass}}"></i></div>
    <div [innerHTML]="messageContent"></div>
    <div><button title="Close" type="button" class="btn-transparent close" (click)="closeMessage($event)">&times;</button></div>
</div>